import {Avatar,Flex,Link,Spacer,Text,VStack} from "@chakra-ui/react";
import {BsArrowRight} from "react-icons/bs";

export interface NotificationListItemProps {
  icon: string;
  date: string;
  title: string;
  onClick?: () => void;
}

export const NotificationListItem = (props: NotificationListItemProps) => {
  const { icon, date, title, onClick } = props;
  const options = { year: "numeric", month: "long", day: "numeric" } as const;
  const reformattedDate = new Date(date);

  return (
    <Flex
      gap={8}
      p="10px 15px"
      bgColor="white"
      alignItems="center"
      borderRadius="10px"
      _hover={{
        transform: "scale(1.025)",
      }}
      cursor="pointer"
      transition="transform 0.2s"
      onClick={onClick}
    >
      <Avatar name="Notification avatar" src={icon} />
      <VStack alignItems="flex-start" spacing={0}>
        <Text color="blueGray.500" fontSize="sm">
          {reformattedDate.toLocaleDateString("en-US", options)}
        </Text>
        <Text color="black" fontWeight="bold" fontSize="md">
          {title}
        </Text>
      </VStack>
      <Spacer />
      <Link
        color="blueGray.500"
        alignSelf="flex-end"
        fontSize="sm"
        display="flex"
        alignItems="center"
      >
        More
        <BsArrowRight />
      </Link>
    </Flex>
  );
};
